<template>
    <div>
        <div v-for="(dependant, idx) in dependants" :key="idx"
             class="d-flex align-items-center border rounded py-3 pl-3 pr-1 my-2">
            <div class="flex-grow-1">
                {{ getFieldFullLabelByPath(dependant.path) }}
                <AppSwitch
                    :value="dependant.required"
                    @toggle="onRequiredToggle(dependant)"
                    class="mt-2">
                    <template v-slot:label>
                        <span>Required</span>
                    </template>
                </AppSwitch>
            </div>
            <AppButton @click="onRemoveDependency(dependant)"
                       type="danger"
                       circle rounded text
                       class="ml-2">
                <i class="fal fa-trash-alt"></i>
            </AppButton>
        </div>
        <v-popover :open.sync="addDependencyOpen">
            <span class="text-purple clickable">
                Add
            </span>
            <template v-slot:popover="{ isOpen }">
                <multiselect
                    v-if="isOpen"
                    :options="availableDependants"
                    @input="onAddDependency"
                    placeholder="Select dependency"
                    trackBy="path"
                    autofocus
                    :customLabel="f => getSectionLabelByKey(f.section.key) + ': ' + f.label"/>
            </template>
        </v-popover>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {sortBy} from 'lodash'
import AppButton from '@/components/buttons/AppButton.vue'
import AppSwitch from '@/components/shared/AppSwitch.vue'

export default {
    name: 'FieldDependantsEditor',
    components: {AppSwitch, AppButton},
    props: {
        field: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            addDependencyOpen: false
        }
    },
    computed: {
        ...mapGetters('doc_viewer_settings', [
            'fields',
            'sections'
        ]),

        dependants() {
            return this.field.dependants || []
        },

        availableDependants() {
            return sortBy(this.fields.filter(f => f.path !== this.field.path), 'section.key')
        }
    },
    methods: {
        onAddDependency(dependant) {
            this.$emit('update', [...this.dependants, {path: dependant.path}])
            this.addDependencyOpen = false
        },

        onRemoveDependency(dependant) {
            this.$emit('update', this.dependants.filter(d => d.path !== dependant.path))
        },

        onRequiredToggle(dependant) {
            this.$emit('update', this.dependants.map(d => {
                if (d.path === dependant.path) {
                    d.required = !d.required
                }
                return d
            }))
        },

        getFieldByPath(path) {
            return this.fields.find(f => f.path === path)
        },

        getSectionLabelByKey(sectionKey) {
            const section = this.sections.find(s => s.key === sectionKey)
            return section && section.label ? section.label : sectionKey
        },

        getFieldFullLabelByPath(path) {
            const field = this.getFieldByPath(path)
            return field && field.label ? `${this.getSectionLabelByKey(field.section.key)}: ${field.label}` : path
        }
    }
}
</script>

<style scoped>

</style>
